
module.exports = {
  X_REGEX: /^x[0-9]?$/,
  Y_REGEX: /^y[0-9]?$/,
  COMMAND_SPLIT_REGEX: /([a-zA-Z][0-9\-\.\s\,]*)/
}
